function filenameFromPath(pathOrUrl) {
  const raw = String(pathOrUrl || "cms-image").split("?")[0];
  const segment = raw.split("/").filter(Boolean).pop() || "cms-image";
  if (/\.(webp|png|jpe?g|gif|svg|avif)$/i.test(segment)) {
    return segment;
  }
  return `${segment.replace(/\.[^.]+$/, "") || "cms-image"}.webp`;
}

/** Download a CMS image using its resolved preview URL. */
export async function downloadCmsImage(previewUrl, storedPath) {
  if (!previewUrl) {
    return;
  }

  const filename = filenameFromPath(storedPath || previewUrl);

  try {
    const response = await fetch(previewUrl);
    if (!response.ok) {
      throw new Error(`Download failed: ${response.status}`);
    }

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  } catch {
    const link = document.createElement("a");
    link.href = previewUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
